(function () {
  const KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UD4e5g';
  const MIN_DELAY = 4000;
  const MAX_DELAY = 8000;

  function loadKlaviyo() {
    if (window.__klaviyoLoaded) return;
    if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]')) return;

    window.__klaviyoLoaded = true;

    const script = document.createElement('script');
    script.src = KLAVIYO_SRC;
    script.async = true;
    document.head.appendChild(script);
  }

  function loadWhenIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadKlaviyo, { timeout: 3000 });
    } else {
      setTimeout(loadKlaviyo, 1000);
    }
  }

  function init() {
    setTimeout(loadWhenIdle, MIN_DELAY);
    setTimeout(loadKlaviyo, MAX_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();